import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';
import { ButtonType, CallToActionKind } from '@/types';
import { FC } from 'react';

import styles from './ModalFooter.ds.module.scss';
import SelectDropdown from '@/components/common/SelectDropdown';
import DropdownDs from '@/components/common/design-system/Dropdown.ds';
import AvailabilityIndicator from '@/components/common/AvailabilityIndicator';
import { useAppSelector } from '@/redux';
import { selectAddToCartModalInfos } from '@/redux/slices/product.slice';
import { useTranslation } from 'next-i18next';
import { selectStoreConf } from '@/redux/slices/root.slice';
import { getCurrentItem } from '@/utils/productUtils';

type buttonModal = {
  label?: string;
  action?: (arg?: unknown) => void;
  type?: ButtonType;
  formId?: string;
}

type Dropdown = {
  setQuantity: (quantity: number) => void;
  quantity: number;
  options: { label: string, value: string }[];
}

export type ModalFooterDsProps = {
  confirm?: buttonModal;
  cancel?: buttonModal;
  sticky?: boolean;
  groupVariant?: 'primary' | 'secondary' | 'tertiary' | 'addToCart';
  direction?: 'column' | 'row';
  dropdown?: Dropdown
}

export const ModalFooterDs: FC<ModalFooterDsProps> = (
  { confirm, cancel, sticky = false, groupVariant = 'primary', direction = 'row', dropdown }
) => {
  const t = useTranslation().t;
  const { productToAdd } = useAppSelector(selectAddToCartModalInfos);
  const storeConf = useAppSelector(selectStoreConf);

  const buttonsVariant = (() => {
    switch (groupVariant) {
      case 'primary':
        return [CallToActionKind.PRIMARY, CallToActionKind.TERTIARY];
      case 'secondary':
        return [CallToActionKind.PRIMARY, CallToActionKind.SECONDARY];
      case 'tertiary':
        return [CallToActionKind.SECONDARY, CallToActionKind.TERTIARY];
      case 'addToCart':
        return [CallToActionKind.PRIMARY];
    }
  })();

  const containerClassNames = [
    sticky ? styles.sticky : styles.footer,
    direction === 'column' ? styles.column : '',
    groupVariant === 'addToCart' ? styles['add-to-cart'] : ''
  ].join(' ');

  const selectedItem: any = productToAdd ? getCurrentItem(productToAdd) : {};

  return (
    <div className={containerClassNames} data-test-id="modal-footer">
      {groupVariant === 'addToCart' && (
        <DropdownDs
          onChange={dropdown.setQuantity} options={dropdown.options} value={dropdown.quantity}
          isFullWidth={false}
        />
      )}
      {confirm?.label && (
        <CallToActionContainer
          id="confirm-btn"
          onClick={confirm?.action && (() => confirm?.action?.())}
          type={confirm.type}
          kind={buttonsVariant[0]}
          form={confirm.formId}
          fullWidth
        >
          {confirm.label}
        </CallToActionContainer>
      )}

      {cancel?.label && (
        <CallToActionContainer
          id="cancel-btn"
          onClick={() => cancel?.action?.()}
          kind={buttonsVariant[1]}
          fullWidth
        >
          {cancel.label}
        </CallToActionContainer>
      )}

      {groupVariant === 'addToCart' && (
        <AvailabilityIndicator
          t={t}
          product={productToAdd}
          currentItem={selectedItem}
          storeId={storeConf.storeId}
          locale={storeConf.locale}
          customClassName={styles['availability-indicator']}
          labelClassName={styles.label}
        />
      )}
    </div>
  );
};

export default ModalFooterDs;
